// extracted by mini-css-extract-plugin
export default {"noteRow":"NotesTable__noteRow___hfrJY","icon":"NotesTable__icon___SATq_","clearFilter":"NotesTable__clearFilter___t04cW","headings":"NotesTable__headings___wGDux"};